// extracted by mini-css-extract-plugin
module.exports = {"banner":"Story_banner__b6j_O","label":"Story_label__z6gO4"};